import React from 'react'
import ExpertView from 'components/shared/ExpertViewSearch';
import styles from 'modules/playlists/components/Playlist/Playlist.module.scss'
import clsx from 'clsx';
import Skeleton from 'components/shared/Skeleton';

type Props = {
  data: any,
  loading?: boolean,
}

export default function ExpertGrid({ data, loading }: Props) {
  if (loading && !data?.length) {
    return (
      <div className={styles.playlistPosts}>
        {Array.from(Array(12).keys()).map((item: number) => (
          <div className={styles.playlistItem} key={item}>
            <Skeleton className={styles.playlistItemSkeleton} />
          </div>
        ))}
      </div>
    )
  }

  if (!data?.length) {
    return null;
  }
  return (
    <div className={clsx(
      styles.playlistPosts,
      loading && styles.playlistPosts_loading,
    )}
    >
      {data?.map((expert) => (
        <div
          className={styles.playlistItem}
          key={expert?.objectID}
        >
          <ExpertView
            data={{ data: expert }}
            className={styles.gridPostItem}
          />
        </div>
      ))}
    </div>
  )
}
